import React from "react";

const SelectField = ({ name, label, value, onChange, options, ...props }) => (
  <div className="relative mb-4 flex w-full flex-col items-end">
    <label className="text-sm leading-7 text-gray-600 mb-2 font-medium">{label}</label>
    <select
      dir="rtl"
      name={name}
      value={value}
      required
      onChange={onChange}
      {...props}
      className="w-full rounded border border-gray-300 bg-white px-3 py-1 text-base leading-8 text-gray-700 outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
    >
      {options.map((option) => (
        <option value={option.id} key={option.id}>
          {option.name}
        </option>
      ))}
    </select>
  </div>
);

export default SelectField;
